module.exports = __webpack_public_path__ + "static/media/物业项目情况表.535e45d9.docx";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/xieyi/物业项目情况表.docx
// module id = 547
// module chunks = 0